import map_component from "@/components/map_component.vue";
import top_bar from "@/components/top_bar.vue";
import side_bar from "@/components/side_bar.vue";
import router from "@/router";

export default {
  name: "Home",
  components: {
    map_component,
    top_bar,
    side_bar
  },
  props: ["countryIdentifier", "facilityType", "scaleType"],
  async created() {
    const countriesGeoserver = await fetch(
      process.env.VUE_APP_GEOSERVER_URL +
        "service=WFS&version=1.0.0&request=GetFeature&typeName=health-acc%3Acountries_global&maxFeatures=500&outputFormat=application%2Fjson"
    );
    this.countries = await countriesGeoserver.json();

    let filteredCountries = await this.countries.features.filter(obj => {
      return obj.properties.active === true;
    });

    this.availableCountries = await filteredCountries.sort(function(a, b) {
      if (a.properties.country_name < b.properties.country_name) {
        return -1;
      }
      if (a.properties.country_name > b.properties.country_name) {
        return 1;
      }
      return 0;
    });

    if (this.countryIdentifier) {
      this.countryFromURL();
    } else {
      console.log("no instant routing");
    }
  },
  watch: {
    countryIdentifier() {
      this.countryFromURL();
    }
  },
  data: () => ({
    sidebarVisible: false,
    layerName: "",
    countryCode: "",
    layerStyle: "",
    availableCountries: [],
    country: "",
    layerTransparency: 70,
    countries: [],
    chosenCountry: "",
    showFacilities: false
  }),
  methods: {
    sidebar(show) {
      this.sidebarVisible = show;
    },
    getCountryCode(cCode) {
      this.countryCode = cCode;
    },
    getCountryName(cName) {
      this.countryName = cName;
    },
    getLayerName(lName) {
      this.layerName = lName;
    },
    getLayerStyle(lStyle) {
      this.layerStyle = lStyle;
    },
    getAvailableCountries(aCountries) {
      this.availableCountries = aCountries;
    },
    countryChosen() {
      router.push(
        "countries/" + this.chosenCountry.properties.iso_code.toLowerCase()
      );
      this.chosenCountry = "";
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    resetSelectedCountry() {
      this.country = "";
    },
    getLayerTransparency(transparencyValue) {
      this.layerTransparency = transparencyValue;
    },
    getShowFacilities(showFacilities) {
      this.showFacilities = showFacilities == "true";
    },
    countryFromURL() {
      if (!this.countryIdentifier) {
        this.sidebar(false);
      } else {
        let country_iso = this.availableCountries.filter(obj => {
          return (
            obj.properties.iso_code === this.countryIdentifier.toUpperCase()
          );
        });
        if (country_iso.length < 1) {
          //console.log(this.countryIdentifier)
          console.log("404");
          router.push("/404");
        } else {
          //check if test objt is empty, push 404
          this.country = country_iso[0];
        }
      }
    }
  }
};
